import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { SupplierAPIKeyStatusTypesEnum } from "../../pages/supplier/enums";

@Pipe({
	name: "apiKeyStatusTypes"
})
export class ApiKeyStatusTypesPipe implements PipeTransform {
	currentLanguage: string = "de";

	constructor(private translateService: TranslateService) {
		this.translateService = translateService;
		this.currentLanguage = this.translateService.currentLang;
		this.translateService.onLangChange.subscribe((response) => {
			this.currentLanguage = response.lang;
		});
	}

	transform(value: string, ...args: unknown[]) {
		if (value) {
			return Object.keys(SupplierAPIKeyStatusTypesEnum).find(
				(key) => SupplierAPIKeyStatusTypesEnum[key] === value
			);
		}
	}
}
